module.exports = __webpack_public_path__ + "img/email.3f1681c2.svg";